module.exports = __webpack_public_path__ + "img/game_main_pc_200_off.684d68f9.png";